import { render, staticRenderFns } from "./BulkFileUpload.vue?vue&type=template&id=826aa13e&"
import script from "./BulkFileUpload.vue?vue&type=script&lang=js&"
export * from "./BulkFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports